<template>
  <div class="control-input" v-show="visibility">
    <div v-on:click="openParameterModal" class="control-button">
      Enter Parameters
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import timeSlices from '../../util/density/timeSlices';
  
  export default {
    name: 'VueButtonControl',
    props: [
		'readonly',
		'emitter',
		'ikey',
		'getData',
		'putData',
		'nodeID',
		'valueNames' // info which parameters need to be set.
    ],
	data: () => {
      return {
			value: [],
			visibility: false,
		}
    },
    mounted() {
		
		
      this.value = this.getData(this.ikey);
    },
    /*destroyed() {
      Vue.prototype.$eventHub.$off('vueDistPreview');
    },*/
    methods: {
      openParameterModal(){
        // Trigger modal
		
		// ensure the latest data is available
		this.value = this.getData(this.ikey);
		
		let templateObject = {};
		for (let key of this.valueNames) {
			templateObject[key] = undefined;
		}
		
		// create missing timeslots
		if ( this.value == undefined){
			this.value = [];
		}
		for (let i=0; i<timeSlices();i++){
			if (this.value[i] == undefined){
				this.value[i] = Object.assign({}, templateObject); // ensure we really copy and not only have a reference
			}
		}
		
		
		let givenName = this._props.emitter.selected.list[0].data.title?this._props.emitter.selected.list[0].data.title:this._props.emitter.selected.list[0].name;
        Vue.prototype.$eventHub.$emit("showParameterModal",
			{
				isParameterModalShown: true, 
				parameterModalData:{
					parameterData: this.value,
					title: givenName,
					nodeid: this.nodeID
				}
            });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .control-button {
    //font-size: 1rem;
    //margin-right: 0px;
    cursor: pointer;
    color: black;
    padding: 5px 8px;
    border: 1px solid #51A7DD;
    border-radius: 16px;
    background: rgba(230, 230, 230, 1);
    //width: 150px;
    //overflow: hidden;
    //text-overflow: ellipsis;
    //white-space: nowrap;
  }

</style>
